const customRugPadTermsHeadingSiteMessageKey = "custom_rugPadTerms_heading";
const customRugTermsHeadingSiteMessageKey = "custom_rugTerms_heading";
const customProductType = "Rug Pad";
const customProduct = "-custom";
const customStandardProduct = "-cstd";
const customExpiditeProduct = "-cexp";
const configuratorTag = "configurator";
const optionNamePackaging = "packaging";
const termsAndConditionsSiteMessageKey = "custom_agreeToTermsAndConditions";
const productType = "Rug";
const rollServiceUnitPrice = 5.00;
const Products = [
  { value: "Rug", label: "Rugs" },
  { value: "Accent", label: "Accents" },
  { value: "Furniture", label: "Furniture" },
  { value: "Lighting", label: "Lighting" },
  { value: "Mirror", label: "Mirrors" },
  { value: "Pillow", label: "Pillows" },
  { value: "Pouf", label: "Poufs" },
  { value: "Lamp", label: "Lamps" },
  { value: "Art", label: "Art" },
  { value: "Throw", label: "Throws" },
  { value: "Barware", label: "Barware" }
];

 const Labels = [
    { value: "W", label: "WHOLESALE" },
    { value: "T", label: "STANDARD " },
    { value: "M", label: "MSRP" },
];

 const CATEGORY_MAP: Record<string, string> = {
    Pillows: "/Catalog/Textiles/Pillows",
    Poufs: "/Catalog/Textiles/Poufs",
    Throws: "/Catalog/Textiles/Throws",
    Mirrors: "/Catalog/Wall-Decor/All",
    Art: "/Catalog/Wall-Decor/Art-and-Accents",
    Rug: "/Catalog/Rugs/All",
    Lamps: "/Catalog/Lighting/All",
    Accent: "/Catalog/Accents/All",
};

const Constant = {
    customRugPadTermsHeadingSiteMessageKey,
    customRugTermsHeadingSiteMessageKey,
    customProductType,
    customProduct,
    customStandardProduct,
    customExpiditeProduct,
    configuratorTag,
    optionNamePackaging,
    termsAndConditionsSiteMessageKey,
    productType,
    rollServiceUnitPrice,
    Products,
    Labels,
    CATEGORY_MAP
};

export default Constant;
